import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { FreelancerBreakpoints } from '@freelancer/ui/breakpoints';
import { VideoObjectFit } from '@freelancer/ui/video';

@Component({
  standalone: false,
  selector: 'fl-section-hero-video-background',
  template: `
    @if (isDesktop && !error) {
      <fl-video
        class="HeroVideo desktop:show"
        [disableControls]="true"
        [autoPlay]="true"
        [loop]="true"
        [objectFit]="VideoObjectFit.COVER"
        [src]="src"
        [loadTimeout]="loadTimeout"
        (error)="error = true"
      >
      </fl-video>
    } @else {
      <fl-picture
        class="desktop:show"
        [isBackgroundImage]="true"
        [src]="fallbackImageSrc"
      ></fl-picture>
    }
  `,
  styleUrls: ['./section-hero-video-background.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeroVideoBackgroundComponent implements OnInit {
  private platformId = inject(PLATFORM_ID);
  private breakpointObserver = inject(BreakpointObserver);

  VideoObjectFit = VideoObjectFit;

  isDesktop = false;
  loadTimeout = 10_000;

  /** A static background image to display when video fails */
  @Input() fallbackImageSrc: string;
  @Input() src: string;

  @HostBinding('attr.data-error') error = false;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isDesktop = this.breakpointObserver.isMatched(
        FreelancerBreakpoints.DESKTOP_SMALL,
      );
    }
  }
}
